import { createFileRoute, redirect } from '@tanstack/react-router';

export const Route = createFileRoute('/admin-console/user-access/')({
    beforeLoad: () => {
        throw redirect({ to: '/admin-console/user-access/users', replace: true });
    },
});
